module.exports = __webpack_public_path__ + "img/katja-wolter-avatar.b95d5acc.jpg";